import Modal from "../../molecules/Modal";
import { motorAPI } from "../../../api/fetch-api";
import { useState, useEffect, useCallback } from "react";
import { formatContact, validateEmail } from "../../utils/helper";
import { Cache } from "aws-amplify";
import MainDriver from "../Common/MainDriver";

const OtherDetailsRenewal = (props) => {
  const renewalData = Cache.getItem("renewalData");
  const [loading, setLoading] = useState(true);
  const [mortgageList, setMortgageList] = useState([]);
  const [otherDetails, setOtherDetails] = useState(props.otherDetails);
  const [btnMortgagee, setBtnMortgagee] = useState(
    props.otherDetails.mortgageeFlag
  );
  const [showMortgageeDetails, setShowMortgageeDetails] = useState(
    props.otherDetails.mortgageeFlag === "Y"
  );
  const [owner, setOwner] = useState(otherDetails.owner);
  const [btnValue, setBtnValue] = useState(otherDetails.isOwner);
  const [isLoadingDriver, setIsLoadingDriver] = useState(true);

  const clientInfo = JSON.parse(Cache.getItem("clientInfo")).resultData;
  const initNamedDriver = {
    name: `${clientInfo.firstName} ${clientInfo.middleName} ${clientInfo.lastName}`,
    birthday: clientInfo.birthday,
  };


  const [driverDetails, setDriverDetails] = useState({});

  const handleMainDriverData = (data) => {
    setDriverDetails(data);
    setOtherDetails((prevState) => {
      const updatedDetails = {
        ...prevState,
        drivers: [
          {
            birthday: data.birthday,
            gender: data.driverGender,
            isPrimaryDriver: data.isPrimaryDriver,
            licenseType: data.driverLicenseType,
            name: data.driverName,
          },
        ],
        driver: {
          birthday: data.birthday,
          gender: data.driverGender,
          isPrimaryDriver: data.isPrimaryDriver,
          licenseType: data.driverLicenseType,
          name: data.driverName,
        },
      };
      props.saveData(updatedDetails);
      return updatedDetails;
    });
  };

  const handleClickMortgagee = (e) => {
    const { value } = e.target;
    setOtherDetails((prevState) => {
      const updatedDetails = { ...prevState, mortgageeFlag: value };
      props.saveData(updatedDetails);
      return updatedDetails;
    });
    setShowMortgageeDetails(value === "Y");
    setBtnMortgagee(value);
  };

  const handleClickOwner = (e) => {
    const { value } = e.target;
    const isOwner = value === "Y";
    setOwner(isOwner);
    setBtnValue(value);

    const clientFullName = `${clientInfo.firstName} ${clientInfo.middleName} ${clientInfo.lastName}`;
    const renewalFullName = `${renewalData.client.firstName} ${renewalData.client.middleName} ${renewalData.client.lastName}`;

    setOtherDetails((prevState) => {
      const updatedDetails = {
        ...prevState,
        isOwner: isOwner ? "Y" : "N",
        ownerName: isOwner
          ? `${clientInfo.firstName} ${clientInfo.middleName} ${clientInfo.lastName}`
          : "",
      };
      props.saveData(updatedDetails);
      return updatedDetails;
    });
  };

  const handleUpdates = (e) => {
    const { name, value } = e.target;
    setOtherDetails((prevDetails) => {
      const updatedDetails = { ...prevDetails, [name]: value };
      props.saveData(updatedDetails);
      return updatedDetails;
    });
  };

  const fetchMortgageList = useCallback(async () => {
    try {
      const data = await motorAPI.getMortgagee();
      setMortgageList(data);
      setLoading(false);
    } catch (err) {
      console.error("Mortgage Error: ", err);
    }
  }, []);

  useEffect(() => {
    const renewalData = otherDetails;
    let driverData = {};
    if (renewalData?.drivers?.length) {
      if (
        initNamedDriver.name.toLowerCase() != renewalData.drivers[0].name.toLowerCase()
      ) {
        renewalData.drivers[0].isPrimaryDriver = "N";
      } else {
        renewalData.drivers[0].isPrimaryDriver = "Y";
      }
      renewalData.drivers[0].driverName = renewalData.drivers[0].name;
      renewalData.drivers[0].driverGender = renewalData.drivers[0].gender;
      renewalData.drivers[0].driverLicenseType =
        renewalData.drivers[0].licenseType;
      driverData = renewalData.drivers[0];
    } 
    else if(renewalData.driver && renewalData.driver?.name) {
      if (
        initNamedDriver.name.toLowerCase().trim() != renewalData.driver?.name.toLowerCase()
      ) {
        renewalData.driver.isPrimaryDriver = "N";
      } else {
        renewalData.driver.isPrimaryDriver = "Y";
      }
      renewalData.driver.driverName = renewalData.driver.name;
      renewalData.driver.driverGender = renewalData.driver.gender;
      renewalData.driver.driverLicenseType = renewalData.driver.licenseType;
      driverData = renewalData.driver;
    }
    else {
      driverData = {
        isPrimaryDriver: "Y",
        driverName: `${clientInfo.firstName} ${clientInfo.middleName} ${clientInfo.lastName}`,
        birthday: clientInfo.birthday,
        driverGender: otherDetails?.driver?.gender || "",
        driverLicenseType: otherDetails?.driver?.licenseType || "",
      };
    }
    setDriverDetails(driverData);
    props.handleNextState(() => SaveForm());
  }, []);

  useEffect(() => {
    fetchMortgageList();
  }, [fetchMortgageList]);

  useEffect(() => {
    if (!isLoadingDriver) handleMainDriverData(driverDetails);
    const timer = setTimeout(() => setIsLoadingDriver(false), 1000);
    return () => clearTimeout(timer);
  }, [driverDetails]);

  const SaveForm = () => {
    //console.log("Saving otherDetails: ", otherDetails);
  };

  return (
    <div>
      <div className="text-left mb-32">
        <h3 className="text-lg font-bold title-font mb-5">
          A few more questions about your car...
        </h3>

        {/* Owner Question */}
        <div>
          <span className="block text-center font-semibold text-gray-500">
            Are you the registered owner of this vehicle?
          </span>
          <img
            alt="car-owner"
            src="/images/motor/motor-2.png"
            className="mx-auto"
            width={300}
          />
          <div className="flex">
            {["Y", "N"].map((value) => (
              <div className="flex-1 text-center">
                <button
                  key={value}
                  type="button"
                  className={`py-3 w-11/12 rounded-full ${
                    btnValue === value
                      ? "bg-blue-600 text-white"
                      : "bg-white text-gray-500 border border-gray-500"
                  }`}
                  onClick={handleClickOwner}
                  value={value}
                >
                  {value === "Y" ? "YES" : "NO"}
                </button>
              </div>
            ))}
          </div>
        </div>

        {otherDetails.isOwner === "N" && (
          <div className="my-10">
            <span className="block font-semibold">
              Please provide the name of the vehicle’s owner as shown in the
              OR/CR.
            </span>
            <span className="block font-semibold mt-2">
              Any discrepancy in ownership may lead to claim denial.
            </span>
            <input
              className="text-center input-form mt-5"
              name="ownerName"
              onChange={handleUpdates}
              value={otherDetails.ownerName}
              placeholder="Owner's Name"
              required
            />
          </div>
        )}

        {/* Mortgage Question */}
        <div className="mt-10">
          <span className="block text-center font-semibold text-gray-500">
            Is the car mortgaged?
          </span>
          <img
            alt="car-mortgagee"
            src="/images/motor/motor-3.png"
            className="mx-auto"
            width={300}
          />

          <div className="flex">
            {["Y", "N"].map((value) => (
              <div className="flex-1 text-center">
                <button
                  key={value}
                  type="button"
                  className={`py-3 w-11/12 rounded-full ${
                    btnMortgagee === value
                      ? "bg-blue-600 text-white"
                      : "bg-white text-gray-500 border border-gray-500"
                  }`}
                  onClick={handleClickMortgagee}
                  value={value}
                >
                  {value === "Y" ? "YES" : "NO"}
                </button>
              </div>
            ))}
          </div>
        </div>

        {showMortgageeDetails && (
          <div className="my-10">
            <span className="block text-center font-semibold">
              Please select mortgagee
            </span>
            <select
              name="mortgagee"
              className="input-border-none focus:outline-none focus:shadow-outline mt-5"
              onChange={handleUpdates}
              value={otherDetails.mortgagee}
              required
            >
              <option value="">Select mortgagee</option>
              {loading ? (
                <option>Loading data...</option>
              ) : (
                mortgageList.map((page, index) => (
                  <option key={page.code} value={page.code}>
                    {page.name}
                  </option>
                ))
              )}
            </select>

            {/* Additional Mortgagee Info */}
            <div className="mt-8">
              <p className="title-font">
                If you wish us to send your insurance policy to your bank,
                please fill in these details:
              </p>
              {[
                "contactPerson",
                "contactNumber",
                "officeAddress",
                "emailAddress",
              ].map((field) => (
                <div key={field} className="mb-3">
                  <label className="block text-gray-500 text-sm font-bold">
                    {field
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                    :
                  </label>
                  <input
                    type="text"
                    name={field}
                    onChange={handleUpdates}
                    value={otherDetails[field]}
                    placeholder={`Enter ${field}`}
                    className="input-border-none focus:outline-none focus:shadow-outline"
                    required
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {!isLoadingDriver && (
          <MainDriver
            otherDetails={otherDetails}
            driverDetails={driverDetails}
            setDriverDetails={setDriverDetails}
            onDataChange={handleMainDriverData}
            defaultData={initNamedDriver}
          />
        )}
      </div>
    </div>
  );
};

export default OtherDetailsRenewal;
